__turbopack_context__.v({
  "root": "RichTextBlok-module__iXOnuW__root",
});
